import { render, staticRenderFns } from "./ingredient-form.vue?vue&type=template&id=f1574660&scoped=true&"
import script from "./ingredient-form.vue?vue&type=script&lang=js&"
export * from "./ingredient-form.vue?vue&type=script&lang=js&"
import style0 from "./ingredient-form.vue?vue&type=style&index=0&id=f1574660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1574660",
  null
  
)

export default component.exports